import type React from 'react';
import { useEffect, useRef } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { Message } from './message';

interface MessageData {
  id: string;
  text: string;
  sender: 'user' | 'ai';
  timestamp: Date;
}

interface MessageListProps {
  messages: MessageData[];
  isLoading: boolean;
}

export const MessageList: React.FC<MessageListProps> = ({ messages, isLoading }) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  const containerStyles = {
    flex: 1,
    padding: '16px',
    overflowY: 'auto' as const,
    backgroundColor: '#f8f9fa',
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '12px',
    maxHeight: '340px',
  };

  const loadingContainerStyles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '12px',
  };

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, isLoading]);

  return (
    <Box sx={containerStyles}>
      {messages.map((message) => (
        <Message key={message.id} message={message} />
      ))}

      {isLoading && (
        <Box sx={loadingContainerStyles}>
          <CircularProgress size={20} />
        </Box>
      )}

      <div ref={messagesEndRef} />
    </Box>
  );
};
